export const MODAL_DIALOG__WIRE_FILE = 'MODAL_DIALOG__WIRE_FILE';
